// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DebitCardGetLashPatientDebitCardLast4DefaultResponse {
    static getAttributeTypeMap() {
        return DebitCardGetLashPatientDebitCardLast4DefaultResponse.attributeTypeMap;
    }
}
DebitCardGetLashPatientDebitCardLast4DefaultResponse.discriminator = undefined;
DebitCardGetLashPatientDebitCardLast4DefaultResponse.additionalProperties = false;
DebitCardGetLashPatientDebitCardLast4DefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "string"
    },
];
//# sourceMappingURL=debitCardGetLashPatientDebitCardLast4DefaultResponse.js.map